export const INIT_OFFER = 'INIT_OFFER';
export const INIT_INVALID_OFFER = 'INIT_INVALID_OFFER';

export const INIT_PENCIL_SUCCESS = 'INIT_PENCIL_SUCCESS';
export const INIT_PENCIL_INVALID_DEAL = 'INIT_PENCIL_INVALID_DEAL';

export const MAKE_CURRENT_OFFER = 'MAKE_CURRENT_OFFER';

export const APPLIED_PROGRAM = 'APPLIED_PROGRAM';
export const APPLY_DUE_AT_SIGNING = 'APPLY_DUE_AT_SIGNING';
export const APPLY_ROLL_TO_OPTIONS = 'APPLY_ROLL_TO_OPTIONS';
export const REQUEST_LEASE_CONTRACT_FIELDS = 'REQUEST_LEASE_CONTRACT_FIELDS';

export const UPDATE_SELECTED_INCENTIVES = 'UPDATE_SELECTED_INCENTIVES';
export const LOCATION_STANDARDS_RECONCILED = 'LOCATION_STANDARDS_RECONCILED';
export const UPDATED_ACQFEE_OVERRIDE = 'UPDATED_ACQFEE_OVERRIDE';
export const UPDATED_ACQFEE_UPFRONT_OVERRIDE = 'UPDATED_ACQFEE_UPFRONT_OVERRIDE';
export const UPDATED_ADJUSTED_RESIDUAL_DOLLAR_OVERRIDE = 'UPDATED_ADJUSTED_RESIDUAL_DOLLAR_OVERRIDE';
export const UPDATED_ADJUSTED_RESIDUAL_PERCENT_OVERRIDE = 'UPDATED_ADJUSTED_RESIDUAL_PERCENT_OVERRIDE';
export const UPDATED_BASE_RESIDUAL_DOLLAR_OVERRIDE = 'UPDATED_BASE_RESIDUAL_DOLLAR_OVERRIDE';
export const UPDATED_BASE_RESIDUAL_PERCENT_OVERRIDE = 'UPDATED_BASE_RESIDUAL_PERCENT_OVERRIDE';
export const UPDATED_PROGRAM_RESIDUAL_DOLLAR_OVERRIDE = 'UPDATED_PROGRAM_RESIDUAL_DOLLAR_OVERRIDE';
export const UPDATED_PROGRAM_RESIDUAL_PERCENT_OVERRIDE = 'UPDATED_PROGRAM_RESIDUAL_PERCENT_OVERRIDE';
export const REMOVED_PROGRAM_RESIDUAL_OVERRIDE = 'REMOVED_PROGRAM_RESIDUAL_OVERRIDE';
export const UPDATED_RESIDUAL_FOR_SELECTED_TERM_UPQ = 'UPDATED_RESIDUAL_FOR_SELECTED_TERM_UPQ';
export const UPDATED_BUY_RATE_OVERRIDE = 'UPDATED_BUY_RATE_OVERRIDE';
export const UPDATED_COBUYER = 'UPDATED_COBUYER';
export const SWAPPED_BUYER_COBUYER = 'SWAPPED_BUYER_COBUYER';
export const SWAPPED_GLOBAL_CUSTOMER_IDS = 'SWAPPED_GLOBAL_CUSTOMER_IDS';
export const UPDATED_CREDIT_DECISION_ENABLED = 'UPDATED_CREDIT_DECISION_ENABLED';
export const UPDATE_CURRENT_CALCULATION_ENDPOINT = 'UPDATE_CURRENT_CALCULATION_ENDPOINT';
export const SET_PROGRAM_FALLBACK_OVERRIDES = 'SET_PROGRAM_FALLBACK_OVERRIDES';
// TODO Delete UPDATED_CREDIT_DECISION_LENDER_NAME after feature toggle enableAppliedLenderInfo has been deleted
export const UPDATED_CREDIT_DECISION_LENDER_NAME = 'UPDATED_CREDIT_DECISION_LENDER_NAME';
export const UPDATED_CREDIT_DECISION_LENDER = 'UPDATED_CREDIT_DECISION_LENDER';
export const UPDATE_CREDIT_DECISION_LENDER_WITH_ADDRESS = 'UPDATE_CREDIT_DECISION_LENDER_WITH_ADDRESS';
export const UPDATE_TITLING_LENDER_WITH_ADDRESS = 'UPDATE_TITLING_LENDER_WITH_ADDRESS';
export const UPDATED_CREDIT_DECISION_STATUS = 'UPDATED_CREDIT_DECISION_STATUS';
export const UPDATED_DEALER_MESSAGE = 'UPDATED_DEALER_MESSAGE';
export const UPDATED_DOWN_PAYMENT_DEBOUNCED = 'UPDATED_DOWN_PAYMENT_DEBOUNCED';
export const UPDATED_DOWN_PAYMENT_IMMEDIATE = 'UPDATED_DOWN_PAYMENT_IMMEDIATE';
export const UPDATE_PROFITABILITY_DATA = 'UPDATE_PROFITABILITY_DATA';
export const UPDATED_INCENTIVES_TOTAL_OVERRIDE = 'UPDATED_INCENTIVES_TOTAL_OVERRIDE';
export const UPDATED_MILEAGE_CHARGE_OVERRIDE = 'UPDATED_MILEAGE_CHARGE_OVERRIDE';
export const UPDATED_OFFER_PRICE_DEBOUNCED = 'UPDATED_OFFER_PRICE_DEBOUNCED';
export const UPDATED_OFFER_PRICE_IMMEDIATE = 'UPDATED_OFFER_PRICE_IMMEDIATE';
export const APPLY_DEALER_DISCOUNTS = 'APPLY_DEALER_DISCOUNTS';
export const UPDATED_OFFER_TYPE = 'UPDATED_OFFER_TYPE';
export const UPDATED_PAYMENT_GRID_TOGGLE = 'UPDATED_PAYMENT_GRID_TOGGLE';
export const UPDATED_RESERVE_SPLIT_OVERRIDE = 'UPDATED_RESERVE_SPLIT_OVERRIDE';
export const CLEARED_RESERVE_SPLIT_LENDER_CHANGE_MESSAGE = 'CLEARED_RESERVE_SPLIT_LENDER_CHANGE_MESSAGE';
export const REPRICED_FOR_CONTRACTING_LENDER_CHANGE = 'REPRICED_FOR_CONTRACTING_LENDER_CHANGE';
export const UPDATED_RETAIL_PRICE_OVERRIDE = 'UPDATED_RETAIL_PRICE_OVERRIDE';
export const UPDATED_VEHICLE_INFO_DETAILS = 'UPDATED_VEHICLE_INFO_DETAILS';
export const UPDATED_MAX_RESIDUALIZED_MSRP_OVERRIDE = 'UPDATED_MAX_RESIDUALIZED_MSRP_OVERRIDE';
export const UPDATED_SECURITY_DEPOSIT_OVERRIDE = 'UPDATED_SECURITY_DEPOSIT_OVERRIDE';
export const UPDATED_SELL_RATE_OVERRIDE = 'UPDATED_SELL_RATE_OVERRIDE';
export const UPDATED_SELL_RATE_FOR_SELECTED_TERM_UPQ = 'UPDATED_SELL_RATE_FOR_SELECTED_TERM_UPQ';
export const UPDATED_FINANCE_SELL_RATE_FOR_SELECTED_TERM_UPQ = 'UPDATED_FINANCE_SELL_RATE_FOR_SELECTED_TERM_UPQ';
export const UPDATED_BUY_RATE_FOR_SELECTED_TERM_UPQ = 'UPDATED_BUY_RATE_FOR_SELECTED_TERM_UPQ';
export const UPDATED_SHOPPER = 'UPDATED_SHOPPER';
export const UPDATED_SHOPPER_CONTACT = 'UPDATED_SHOPPER_CONTACT';
export const UPDATED_SHOPPER_CONTACT_RETRY = 'UPDATED_SHOPPER_CONTACT_RETRY';
export const BUSINESS_CONVERSION_SUCCESS = 'BUSINESS_CONVERSION_SUCCESS';
export const UPDATED_SHOPPER_MESSAGE = 'UPDATED_SHOPPER_MESSAGE';
export const UPDATED_SHOPPER_ZIP = 'UPDATED_SHOPPER_ZIP';
export const UPDATE_IS_TARGET_OUT_OF_POCKET = 'UPDATE_IS_TARGET_OUT_OF_POCKET';
export const UPDATED_TOTAL_TAX_OVERRIDE = 'UPDATED_TOTAL_TAX_OVERRIDE';
export const UPDATE_PAYMENT_FEES_OVERRIDE = 'UPDATE_PAYMENT_FEES_OVERRIDE';
export const UPDATED_TOTAL_TAX_UPFRONT_OVERRIDE = 'UPDATED_TOTAL_TAX_UPFRONT_OVERRIDE';
export const UPDATED_TRADE_IN = 'UPDATED_TRADE_IN';
export const ACCEPT_DEAL_REQUEST = 'ACCEPT_DEAL_REQUEST';
export const ACCEPT_DEAL_SUCCESS = 'ACCEPT_DEAL_SUCCESS';
export const ACCEPT_DEAL_SET_ACCEPTED = 'ACCEPT_DEAL_SET_ACCEPTED';
export const ACCEPT_DEAL_FAILURE = 'ACCEPT_DEAL_FAILURE';
export const ACCEPT_DEAL_RESET = 'ACCEPT_DEAL_RESET';
export const FETCH_OFFER_TYPES_DATA = 'FETCH_OFFER_TYPES_DATA';
export const TOGGLE_RATE_TYPE = 'TOGGLE_RATE_TYPE';
export const INITIALIZE_PAYMENT_GRID_FROM_TEMPLATE = 'INITIALIZE_PAYMENT_GRID_FROM_TEMPLATE';

export const SELECTED_TERM = 'SELECTED_TERM';
export const SELECTED_CREDIT_TIER = 'SELECTED_CREDIT_TIER';
export const UPDATED_MANUAL_CREDIT_SCORE = 'UPDATED_MANUAL_CREDIT_SCORE';
export const CLEAR_MANUAL_CREDIT_SCORE = 'CLEAR_MANUAL_CREDIT_SCORE';
export const UPDATE_CREDIT_SCORE_SOURCE = 'UPDATE_CREDIT_SCORE_SOURCE';

export const SELECTED_ANNUAL_MILES = 'SELECTED_ANNUAL_MILES';

export const CLEAR_OVERRIDES = 'CLEAR_OVERRIDES';
export const CLEAR_OVERRIDES_WITHOUT_INCENTIVES = 'CLEAR_OVERRIDES_WITHOUT_INCENTIVES';
export const UPDATE_OVERRIDES = 'UPDATE_OVERRIDES';

export const CREDIT_APP_SUBMITTED_AWAITING_DECISION = 'CREDIT_APP_SUBMITTED_AWAITING_DECISION';
export const CREDIT_APP_CO_APPLICANT_EMAIL = 'CREDIT_APP_CO_APPLICANT_EMAIL';
export const CREDIT_DECISION_DETAILS_RECEIVED = 'CREDIT_DECISION_DETAILS_RECEIVED';
export const APPLY_CREDIT_DECISION_DETAILS = 'APPLY_CREDIT_DECISION_DETAILS';
export const CREDIT_DECISION_APPROVED = 'CREDIT_DECISION_APPROVED';
export const CREDIT_APP_ZIP_CODE_UPDATED = 'CREDIT_APP_ZIP_CODE_UPDATED';
export const CREDIT_APP_UPDATED_SHOPPER = 'CREDIT_APP_UPDATED_SHOPPER';
export const CREDIT_APP_UPDATED_CO_BUYER = 'CREDIT_APP_UPDATED_CO_BUYER';

export const PAYMENT_RECEIVED = 'PAYMENT_RECEIVED';
export const PAYMENT_REQUESTED = 'PAYMENT_REQUESTED';
export const EQUITY_ALLOCATION_METHOD_BACKFILLED = 'EQUITY_ALLOCATION_METHOD_BACKFILLED';
export const PAYMENT_FAILURE = 'PAYMENT_FAILURE'; // TODO: this is going to be a story to handle failure payment in offer redux
/** Mirrors paymentActionTypes.PAYMENT_ABORTED, so the payment-grid reducer and middleware can see it. */
export const PAYMENT_ABORTED = 'PAYMENT_ABORTED';
/** Mirrors paymentActionTypes.PAYMENT_GRID_ROW_SUPERSEDED, so the payment-grid reducer can see it. */
export const PAYMENT_GRID_ROW_SUPERSEDED = 'PAYMENT_GRID_ROW_SUPERSEDED';
export const FETCH_QUESTIONS_OR_PAYMENT = 'FETCH_QUESTIONS_OR_PAYMENT';

export const SYNC_MESSAGE = 'SYNC_MESSAGE';
export const INIT_SUCCESS = 'INIT_SUCCESS';
export const INIT_INVALID_DEAL_SUCCESS = 'INIT_INVALID_DEAL_SUCCESS';

export const UPDATED_FINANCE_OFFER_PRICE = 'UPDATED_FINANCE_OFFER_PRICE';
export const UPDATED_FINANCE_AND_CASH_OFFER_PRICE = 'UPDATED_FINANCE_AND_CASH_OFFER_PRICE';
export const UPDATED_FINANCE_AND_LEASE_OFFER_PRICE = 'UPDATED_FINANCE_AND_LEASE_OFFER_PRICE';
export const UPDATED_FINANCE_AND_LEASE_AND_CASH_OFFER_PRICE = 'UPDATED_FINANCE_AND_LEASE_AND_CASH_OFFER_PRICE';
export const VEHICLE_RETAIL_PRICE_CHANGED = 'VEHICLE_RETAIL_PRICE_CHANGED';
export const VEHICLE_SUCCESS = 'VEHICLE_SUCCESS';

export const ZIP_EDIT_TERMS_BTN_CLICKED = 'ZIP_EDIT_TERMS_BTN_CLICKED';

export const REFRESH_SESSION_ID_SUCCESS = 'REFRESH_SESSION_ID_SUCCESS';

export const OFFER_SUBMISSION_SUCCESS = 'OFFER_SUBMISSION_SUCCESS';

export const OFFER_SAVE_SUCCESS = 'OFFER_SAVE_SUCCESS';

export const UPDATED_COUNTEROFFER_MESSAGE = 'UPDATED_COUNTEROFFER_MESSAGE';

export const ICO_TRADE_IN_COMPLETED = 'ICO_TRADE_IN_COMPLETED';

export const DISMISS_TERMS_FALLBACK_MESSAGE = 'DISMISS_TERMS_FALLBACK_MESSAGE';

export const DEALXG_GET_SUCCESS = 'DEALXG_GET_SUCCESS';

export const TOGGLE_SHOULD_SHOW_PAYMENTS_GRID = 'TOGGLE_SHOULD_SHOW_PAYMENTS_GRID';
export const TOGGLE_SHOULD_SHOW_PAYMENTS_GRID_FOR_TEMPLATE = 'TOGGLE_SHOULD_SHOW_PAYMENTS_GRID_FOR_TEMPLATE';

export const UPDATE_GRID_HEADERS_SNAPSHOT = 'UPDATE_GRID_HEADERS_SNAPSHOT';
export const SET_SHOULD_SAVE_MULTI_SCENARIO_PAYMENT_GRID = 'SET_SHOULD_SAVE_MULTI_SCENARIO_PAYMENT_GRID';

// dr-dash
export const BOOTSTRAP_SUCCESS = 'BOOTSTRAP_SUCCESS';
export const SWITCH_VEHICLE = 'SWITCH_VEHICLE';
export const CLEAR_VEHICLE_FULFILLMENT = 'CLEAR_VEHICLE_FULFILLMENT';
export const UPDATE_AVAILABLE_INCENTIVES = 'UPDATE_AVAILABLE_INCENTIVES';
export const UPDATE_TERM_AVAILABLE_INCENTIVES = 'UPDATE_TERM_AVAILABLE_INCENTIVES';
export const UPDATE_CASH_AVAILABLE_INCENTIVES = 'UPDATE_CASH_AVAILABLE_INCENTIVES';
export const UPDATED_MANUAL_INCENTIVES = 'UPDATED_MANUAL_INCENTIVES';
export const MODIFY_MANUAL_INCENTIVE = 'MODIFY_MANUAL_INCENTIVE';
export const UPDATED_SPECIAL_PAYMENT_FORMULA = 'UPDATED_SPECIAL_PAYMENT_FORMULA';
export const RESET_SPECIAL_PAYMENT_FORMULA = 'RESET_SPECIAL_PAYMENT_FORMULA';
export const UPDATED_PAYMENT_FREQUENCY = 'UPDATED_PAYMENT_FREQUENCY';
export const UPDATE_MESSAGE_TO_SALESPERSON = 'UPDATE_MESSAGE_TO_SALESPERSON';
export const APPLY_DEALER_PAYMENT_OVERRIDES = 'APPLY_DEALER_PAYMENT_OVERRIDES';

export const CCID_CORGID_UPDATED = 'CCID_CORGID_UPDATED';

export const FETCH_CVI_VEHICLE_SUCCESS = 'FETCH_CVI_VEHICLE_SUCCESS';
export const UPDATE_FINANCE_TERMS_GRID = 'UPDATE_FINANCE_TERMS_GRID';
export const UPDATE_LEASE_TERMS_GRID = 'UPDATE_LEASE_TERMS_GRID';
export const UPDATE_BALLOON_TERMS_GRID = 'UPDATE_BALLOON_TERMS_GRID';
export const UPDATE_FLEX_BUY_TERMS_GRID = 'UPDATE_FLEX_BUY_TERMS_GRID';
export const CLOSE_LENDER_CHANGED_BANNER = 'CLOSE_LENDER_CHANGED_BANNER';
export const FETCH_TERMS_GRID_DATA = 'FETCH_TERMS_GRID_DATA';

export const UPDATE_TAX_ITEMS = 'UPDATE_TAX_ITEMS';

export const CLEAR_TAX_AMOUNTS = 'CLEAR_TAX_AMOUNTS';
export const RESET_TAX_OVERRIDES = 'RESET_TAX_OVERRIDES';

export const RESET_OFFER = 'RESET_OFFER';

export const LOAD_PAYMENT_GRID_DATA = 'LOAD_PAYMENT_GRID_DATA';

export const LOAD_PAYMENT_GRID_TERM_DATA = 'LOAD_PAYMENT_GRID_TERM_DATA';

export const INITIALIZE_PAYMENT_GRID_TERMS = 'INITIALIZE_PAYMENT_GRID_TERMS';

export const INITIALIZE_PAYMENT_GRID_CASHDOWN = 'INITIALIZE_PAYMENT_GRID_CASHDOWN';

export const LOAD_PAYMENT_GRID_LENDER_PROGRAMS = 'LOAD_PAYMENT_GRID_LENDER_PROGRAMS';

export const LOAD_PAYMENT_GRID_TERM_LENDER_PROGRAM = 'LOAD_PAYMENT_GRID_TERM_LENDER_PROGRAM';

export const UPDATE_PAYMENT_GRID_TERM = 'UPDATE_PAYMENT_GRID_TERM';

export const UPDATE_PAYMENT_GRID_CASH_DOWN = 'UPDATE_PAYMENT_GRID_CASH_DOWN';

export const RESET_PAYMENT_GRID = 'RESET_PAYMENT_GRID';
/** Records which calculation engine each grid column resolved to. */
export const SET_PAYMENT_GRID_COLUMN_SOURCES = 'SET_PAYMENT_GRID_COLUMN_SOURCES';
export const SET_PAYMENT_GRID_ORIGINAL_COLUMN_SOURCES = 'SET_PAYMENT_GRID_ORIGINAL_COLUMN_SOURCES';
export const RESTORE_PAYMENT_GRID_TERM_OVERRIDES = 'RESTORE_PAYMENT_GRID_TERM_OVERRIDES';
export const SET_PAYMENT_GRID_CELL_PRICED_AT = 'SET_PAYMENT_GRID_CELL_PRICED_AT';
/** US2085313: merges a stored grid's priced cells back into the terms node on load. */
export const RESTORE_PAYMENT_GRID_TERMS = 'RESTORE_PAYMENT_GRID_TERMS';
export const RESTORE_PAYMENT_GRID_PROGRAMS = 'RESTORE_PAYMENT_GRID_PROGRAMS';
/** Holds a sell rate typed into a grid column with no term yet, keyed by column index. */
export const SET_PAYMENT_GRID_PENDING_SELL_RATE = 'SET_PAYMENT_GRID_PENDING_SELL_RATE';
/** Holds the rate pair a column carried into a term change, keyed by the INCOMING term, for its UPQ fallback. */
export const SET_PAYMENT_GRID_FALLBACK_RATES = 'SET_PAYMENT_GRID_FALLBACK_RATES';
export const SET_PAYMENT_GRID_LEFT_TERMS = 'SET_PAYMENT_GRID_LEFT_TERMS';
export const SET_PAYMENT_GRID_USER_PRICED_TERM = 'SET_PAYMENT_GRID_USER_PRICED_TERM';
export const SET_PAYMENT_GRID_WRITTEN_TERM = 'SET_PAYMENT_GRID_WRITTEN_TERM';
export const CLEAR_PAYMENT_GRID_COLUMN_FIGURES = 'CLEAR_PAYMENT_GRID_COLUMN_FIGURES';
export const CLEAR_PAYMENT_GRID_TERM_PROGRAMS = 'CLEAR_PAYMENT_GRID_TERM_PROGRAMS';
export const CLEAR_PAYMENT_GRID_TERM_RECORDS = 'CLEAR_PAYMENT_GRID_TERM_RECORDS';
export const SET_PAYMENT_GRID_COLUMN_CELLS = 'SET_PAYMENT_GRID_COLUMN_CELLS';
export const RESTORE_PAYMENT_GRID_ROW_QUOTES = 'RESTORE_PAYMENT_GRID_ROW_QUOTES';
export const SET_PAYMENT_GRID_ACTIVE_CELL = 'SET_PAYMENT_GRID_ACTIVE_CELL';
export const SET_PAYMENT_GRID_COLUMN_OVERRIDE = 'SET_PAYMENT_GRID_COLUMN_OVERRIDE';
export const SET_PAYMENT_GRID_RESTORED_INPUTS = 'SET_PAYMENT_GRID_RESTORED_INPUTS';
export const SET_PAYMENT_GRID_CARRIED_OVERRIDE = 'SET_PAYMENT_GRID_CARRIED_OVERRIDE';
export const ADOPT_PAYMENT_GRID_CELL = 'ADOPT_PAYMENT_GRID_CELL';
export const SET_PAYMENT_GRID_DECIDED_COLUMNS = 'SET_PAYMENT_GRID_DECIDED_COLUMNS';
/**
 * Identifies the grid build in progress - the discovery and the rows it fans out - so a superseded build's responses
 * drive neither a row round nor a column verdict.
 */
export const SET_PAYMENT_GRID_BUILD = 'SET_PAYMENT_GRID_BUILD';
export const SET_PAYMENT_GRID_DEAL_PROGRAM = 'SET_PAYMENT_GRID_DEAL_PROGRAM';
export const SET_PAYMENT_GRID_DEAL_TERM_BEFORE_EDIT = 'SET_PAYMENT_GRID_DEAL_TERM_BEFORE_EDIT';
export const HOLD_PAYMENT_GRID_FOR_VEHICLE_SWITCH = 'HOLD_PAYMENT_GRID_FOR_VEHICLE_SWITCH';
export const REBUILD_PAYMENT_GRID_AFTER_VEHICLE_SWITCH = 'REBUILD_PAYMENT_GRID_AFTER_VEHICLE_SWITCH';

export const SET_APPLICATION_NAME = 'SET_APPLICATION_NAME';

export const SET_OFFER_SOURCE = 'SET_OFFER_SOURCE';

export const PAYMENT_GRID_FETCH_VPP_PRODUCTS = 'PAYMENT_GRID_FETCH_VPP_PRODUCTS';
export const INIT_OFFER_CREDIT_TIERS = 'INIT_OFFER_CREDIT_TIERS';

export const HIDE_ACCEPT_FLOW_ON_SUBMIT = 'HIDE_ACCEPT_FLOW_ON_SUBMIT';
export const HIDE_ACCEPTED_FLOW_ON_SUBMIT = 'HIDE_ACCEPTED_FLOW_ON_SUBMIT';

export const PARTIAL_RESET_OVERRIDES = 'PARTIAL_RESET_OVERRIDES';
export const SELECTED_CREDIT_PARTIAL_RESET_OVERRIDES = 'SELECTED_CREDIT_PARTIAL_RESET_OVERRIDES';
export const LOCATION_RESET_OVERRIDES = 'LOCATION_RESET_OVERRIDES';

export const HONOR_LEASE_MILEAGE_CHANGE = 'HONOR_LEASE_MILEAGE_CHANGE';
export const FULL_RESET_OVERRIDES = 'FULL_RESET_OVERRIDES';
export const CHANGE_VEHICLE_UPDATE_OVERRIDES = 'CHANGE_VEHICLE_UPDATE_OVERRIDES';
export const PARTIAL_RESTORE_OVERRIDES = 'PARTIAL_RESTORE_OVERRIDES';
export const UPDATE_FLEX_BUY_PAYMENT = 'UPDATE_FLEX_BUY_PAYMENT';
export const UPDATE_FLEX_BUY_PAYMENT_GRID_DATA = 'UPDATE_FLEX_BUY_PAYMENT_GRID_DATA';
export const UPDATE_FLEX_BUY_PAYMENT_GRID_AXIS_VALUES = 'UPDATE_FLEX_BUY_PAYMENT_GRID_AXIS_VALUES';
export const LOADING_UPDATE_FLEX_BUY_TERM_AND_PERCENT = 'LOADING_UPDATE_FLEX_BUY_TERM_AND_PERCENT';
export const LOADING_UPDATE_FLEX_BUY_CASH_DOWN = 'LOADING_UPDATE_FLEX_BUY_CASH_DOWN';
export const LOADING_FLEX_BUY_PAYMENT_GRID = 'LOADING_FLEX_BUY_PAYMENT_GRID';
export const UPDATED_FLEX_BUY_PAYMENT_GRID_TOGGLE = 'UPDATED_FLEX_BUY_PAYMENT_GRID_TOGGLE';
export const RESET_FLEX_BUY_PAYMENT_GRID_DATA = 'RESET_FLEX_BUY_PAYMENT_GRID_DATA';
/** US2041815: records when the flex buy grid last priced, which one response fills in full. */
export const SET_FLEX_BUY_PAYMENT_GRID_PRICED_AT = 'SET_FLEX_BUY_PAYMENT_GRID_PRICED_AT';
export const REVERT_FFB_DEAL_TO_BASE_FINANCE = 'REVERT_FFB_DEAL_TO_BASE_FINANCE';

// Balloon Payment Actions
export const UPDATE_BALLOON_PAYMENT = 'UPDATE_BALLOON_PAYMENT';
export const UPDATE_BALLOON_PAYMENT_GRID_DATA = 'UPDATE_BALLOON_PAYMENT_GRID_DATA';
export const UPDATE_BALLOON_PAYMENT_GRID_AXIS_VALUES = 'UPDATE_BALLOON_PAYMENT_GRID_AXIS_VALUES';
export const LOADING_BALLOON_PAYMENT_GRID = 'LOADING_BALLOON_PAYMENT_GRID';
export const UPDATED_BALLOON_PAYMENT_GRID_TOGGLE = 'UPDATED_BALLOON_PAYMENT_GRID_TOGGLE';
export const RESET_BALLOON_PAYMENT_GRID_DATA = 'RESET_BALLOON_PAYMENT_GRID_DATA';
export const REVERT_BALLOON_DEAL_TO_BASE_FINANCE = 'REVERT_BALLOON_DEAL_TO_BASE_FINANCE';

export const UPDATE_DEAL_DEPOSIT = 'UPDATE_DEAL_DEPOSIT';
export const SET_OUTSIDE_LIENHOLDER = 'SET_OUTSIDE_LIENHOLDER';
export const SET_TRANSFER_REGISTRATION_DETAILS = 'SET_TRANSFER_REGISTRATION_DETAILS';
export const SET_PRIOR_LEASE_BALANCE = 'SET_PRIOR_LEASE_BALANCE';
export const SET_PREVIOUS_FINANCE_INPUT_WITHOUT_FFB = 'SET_PREVIOUS_FINANCE_INPUT_WITHOUT_FFB';
export const RESET_PREVIOUS_FINANCE_INPUT_WITHOUT_FFB = 'RESET_PREVIOUS_FINANCE_INPUT_WITHOUT_FFB';

export const SET_LOCK_PAYMENT_INPUTS_IN_SV = 'SET_LOCK_PAYMENT_INPUTS_IN_SV';

export const CREDIT_APP_SEARCH_MERGE_DEAL = 'CREDIT_APP_SEARCH_MERGE_DEAL';
export const CREDIT_APP_COPIED_BY_PARTICIPANTS_SAVE = 'CREDIT_APP_COPIED_BY_PARTICIPANTS_SAVE';

// Mirror of UPDATE_DEAL_REF_ID from @makemydeal/dr-dash-store. Inlined to avoid an
// offer-redux -> dash-store import cycle that @nx/enforce-module-boundaries blocks
// (see the REVERT_MANUALLY_APPLIED_TEMPLATE note in reducers/offerManagement.ts).
// Drift-guarded by a test in dash-store.
export const UPDATE_DEAL_REF_ID = 'UPDATE_DEAL_REF_ID';

export const UPDATED_SECOND_PAYMENT_DUE_DATE_FIELD = 'UPDATED_SECOND_PAYMENT_DUE_DATE_FIELD';
export const UPDATE_DEFERRED_DOWN_PAYMENT = 'UPDATE_DEFERRED_DOWN_PAYMENT';

export const INITIALIZE_T1_ORIGIN_DEAL_INFO = 'INITIALIZE_T1_ORIGIN_DEAL_INFO';

// Balloon Related Actions
export const UPDATED_BALLOON_PAYMENT_AMOUNT = 'UPDATED_BALLOON_PAYMENT_AMOUNT';
export const UPDATED_BALLOON_TYPE = 'UPDATED_BALLOON_TYPE';

// Lease Residual Treatment
export const UPDATE_RESIDUAL_TAB_DISPLAY_TYPE = 'UPDATE_RESIDUAL_TAB_DISPLAY_TYPE';

// AI Related Actions
export const APPLY_RECOMMENDED_VEHICLE_PAYMENT_DETAILS = 'APPLY_RECOMMENDED_VEHICLE_PAYMENT_DETAILS';

export const RESTORE_OVERRIDES_FOR_FALLBACK = 'RESTORE_OVERRIDES_FOR_FALLBACK';
export const CLEAR_OVERRIDES_FALLBACK_SNAPSHOT = 'CLEAR_OVERRIDES_FALLBACK_SNAPSHOT';
export const CAPTURE_OVERRIDES_FALLBACK_SNAPSHOT = 'CAPTURE_OVERRIDES_FALLBACK_SNAPSHOT';
